import i18n from "config/i18next";

i18n.addResources("es", "account", {
  fiscalNumber: "Número de CUIT",
  bankNameLabel: "Nombre del banco *",
  bankNamePlaceholder: "Seleccioná el nombre del banco",
  invalidBank: "Ingresá un valor entre 9 y 22 caracteres",
  sapInterlocutor: "Código de proveedor SAP",
  sapInterlocutorError: "El código debe tener 10 dígitos.",
  fiscalDirection: "Dirección fiscal",
  streetLabel: "Calle *",
  streetPlaceholder: "Ingresá una calle",
  streetNumberLabel: "Número *",
  streetNumberPlaceholder: "Ingresá un número",
  postalCodeLabel: "Código postal *",
  postalCodePlaceholder: "Ingresá un código postal",
  localityLabel: "Ciudad *",
  localityPlaceholder: "Ingresá una ciudad",
  provinceLabel: "Departamento *",
  provincePlaceholder: "Seleccioná un departamento",
  cpError: "Ingresá un número entre 4 y 7 dígitos",
  formatAddressError: "El formato ingresado no es válido",
  fiscalNumberDuplicated: "Este dato ya se encuentra registrado",
});

i18n.addResources("es_CO", "account", {
  typeLabel: "Tipo de cuenta *",
  typePlaceholder: "Seleccioná el tipo de cuenta",
  bankIdentifierLabel: "Número de cuenta *",
  bankIdentifierPlaceholder: "Ingresá el número de cuenta",
  fiscalNumber: "Número de NIT",
  fiscalNumberPlaceholder: "Ingresá el número de NIT",
});

i18n.addResources("es_AR", "account", {
  bankNameLabel: "Nombre del banco",
  bankIdentifierLabel: "Número de CBU *",
  bankIdentifierPlaceholder: "Ingresá el número de CBU",
  bankNamePlaceholder: "Ingresá el nombre del banco",
  invalidBank: "El número ingresado no corresponde a un banco",
  localityLabel: "Localidad *",
  localityPlaceholder: "Ingresá una localidad",
  provinceLabel: "Provincia *",
  provincePlaceholder: "Seleccioná una provincia",
  cpError: "Ingresá un número de 4 dígitos",
  fiscalNumberError: "Ingresá un número de 11 dígitos",
  fiscalNumberPlaceholder: "Ingresá el número de CUIT",
});

i18n.addResources("es_MX", "account", {
  fiscalNumber: "RFC",
  bankIdentifierLabel: "Número de CLABE *",
  bankIdentifierPlaceholder: "Ingresá el número de CLABE",
  invalidBank: "Ingresá un número de 18 cifras",
  localityLabel: "Municipio *",
  localityPlaceholder: "Ingresá un municipio",
  provinceLabel: "Estado *",
  provincePlaceholder: "Seleccioná un estado",
  cpError: "Ingresá un número de 5 dígitos",
  fiscalNumberError: "Ingresá un número de 9 dígitos",
  fiscalNumberPlaceholder: "Ingresá el RFC",
});


i18n.addResources("es_CL", "account", {
  fiscalNumber: "RUT",
  fiscalNumberPlaceholder: "Ingresá el RUT",
  bankIdentifierLabel: "Número de cuenta bancaria *",
  bankIdentifierPlaceholder: "Ingresá el número de cuenta bancaria",
  provinceLabel: "Región *",
  provincePlaceholder: "Seleccioná una región",
  invalidFormat: "El formato es inválido",
  invalidBank: "Ingresá un valor entre 1 y 22 caracteres",
  cpError: "Ingresá un número de 7 dígitos",
});
